module.exports = __webpack_public_path__ + "static/online_treatment_2-22c632e3fc0369a7985cf1c3bd7a6fee.png";